import React from "react";
import MenuLogo from "../../../../assets/images/vd-menu-logo.svg";
import PosLogo from "../../../../assets/images/vd-pos-logo.svg";
import s from "./Header.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { cn, cond } from "../../../../styles/utils";

interface HeaderProps extends React.HTMLAttributes<HTMLHeadElement> {
  product: "pos" | "menu";
}

const LOGO_MAP = {
  pos: PosLogo,
  menu: MenuLogo,
};

const Header = ({ product, ...props }: HeaderProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMenu = location.pathname === "/menu";

  return (
    <header className={s.header} {...props}>
      <div className={s.titleWrapper}>
        <div className={s.logoWrapper}>
          <img src={LOGO_MAP[product]} alt="로고" />
        </div>
        <h1 className={s.title}>체험하기</h1>
      </div>
      <div className={s.switchContainer}>
        <button
          onClick={() => navigate("/menu")}
          className={cn(s.switchButton, cond(isMenu, s.active))}
        >
          브이디 메뉴
        </button>
        <button
          onClick={() => navigate("/pos")}
          className={cn(s.switchButton, cond(!isMenu, s.active))}
        >
          브이디 포스
        </button>
      </div>
    </header>
  );
};

export default Header;
